import { trapFocus, removeTrapFocus } from '@theme/focus';

const STORAGE_KEY = 'little-sama-language-picker-dismissed';

/**
 * Full-screen language picker shown once per visitor. Remembers the visitor's
 * dismissal (whether by picking a language or closing it) in localStorage so
 * it never shows again on that browser.
 */
class LanguagePickerModal extends HTMLElement {
  connectedCallback() {
    if (localStorage.getItem(STORAGE_KEY)) return;

    this.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
    trapFocus(this);

    this.querySelectorAll('[data-language-picker-close]').forEach((element) => {
      element.addEventListener('click', this.close);
    });

    this.querySelector('form')?.addEventListener('submit', () => {
      localStorage.setItem(STORAGE_KEY, '1');
    });

    document.addEventListener('keydown', this.#onKeyDown);
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this.#onKeyDown);
  }

  close = () => {
    localStorage.setItem(STORAGE_KEY, '1');
    this.setAttribute('hidden', '');
    document.body.style.overflow = '';
    removeTrapFocus();
  };

  /** @param {KeyboardEvent} event */
  #onKeyDown = (event) => {
    if (event.key === 'Escape') this.close();
  };
}

if (!customElements.get('language-picker-modal')) {
  customElements.define('language-picker-modal', LanguagePickerModal);
}
